import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import { ProjectIntegrationService } from '@payaca/types/projectIntegrationTypes';
import { isNotNull } from '@payaca/utilities/guards';
import meKeys from './keyFactory';

const GetMyAccountIntegrations = graphql(`
  query MyAccountIntegrations {
    me {
      user {
        account {
          integrations {
            easyPV {
              updatedAt
            }
            openSolar {
              updatedAt
            }
            heatpunk {
              updatedAt
            }
            fornax {
              updatedAt
            }
            spruce {
              updatedAt
            }
          }
        }
      }
    }
  }
`);

const useGetMyAccountIntegrations = () => {
  const { data, ...rest } = useQuery({
    queryKey: meKeys.integrations(),
    queryFn: () => {
      return gqlClient.request(GetMyAccountIntegrations);
    },
  });

  const integrations = data?.me.user.account.integrations;

  const integrationsList: {
    service: ProjectIntegrationService;
    updatedAt: string;
  }[] = [
    integrations?.easyPV
      ? {
          service: 'EASY_PV' as const,
          updatedAt: integrations.easyPV.updatedAt,
        }
      : null,
    integrations?.heatpunk
      ? {
          service: 'HEATPUNK' as const,
          updatedAt: integrations.heatpunk.updatedAt,
        }
      : null,
    integrations?.openSolar
      ? {
          service: 'OPEN_SOLAR' as const,
          updatedAt: integrations.openSolar.updatedAt,
        }
      : null,
    integrations?.fornax
      ? {
          service: 'FORNAX' as const,
          updatedAt: integrations.fornax.updatedAt,
        }
      : null,
    integrations?.spruce
      ? {
          service: 'SPRUCE' as const,
          updatedAt: integrations.spruce.updatedAt,
        }
      : null,
  ].filter(isNotNull);

  return { data: integrationsList, ...rest };
};

export default useGetMyAccountIntegrations;
